import { createContext, useState } from "react";
import PropTypes from "prop-types";

const CHANNEL_PARTNER_AUTH_STORAGE_KEY = "channel-partner-login-user";

const getStoredChannelPartnerUser = () => {
  try {
    const storedUser = localStorage.getItem(CHANNEL_PARTNER_AUTH_STORAGE_KEY);
    return storedUser ? JSON.parse(storedUser) : null;
  } catch {
    localStorage.removeItem(CHANNEL_PARTNER_AUTH_STORAGE_KEY);
    return null;
  }
};

const ChannelPartnerAuthContext = createContext();

export const ChannelPartnerAuthProvider = ({ children }) => {
  const [channelPartnerUser, setChannelPartnerUser] = useState(
    getStoredChannelPartnerUser,
  );

  const loginChannelPartner = (token, userInfo, channelPartner) => {
    const userData = {
      token,
      role: "ChannelPartner",
      userInfo,
      channelPartner,
    };
    localStorage.setItem(
      CHANNEL_PARTNER_AUTH_STORAGE_KEY,
      JSON.stringify(userData),
    );
    setChannelPartnerUser(userData);
  };

  const logoutChannelPartner = () => {
    localStorage.removeItem(CHANNEL_PARTNER_AUTH_STORAGE_KEY);
    setChannelPartnerUser(null);
  };

  return (
    <ChannelPartnerAuthContext.Provider
      value={{ channelPartnerUser, loginChannelPartner, logoutChannelPartner }}
    >
      {children}
    </ChannelPartnerAuthContext.Provider>
  );
};

ChannelPartnerAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChannelPartnerAuthContext;
